import { APICLIENT } from "../shared";
import { apiendpoints } from "../constants/api-endpoints";

// GetInvoice By Application ID
export const getInvoiceByApplicationId = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_InvoiceApplicationId_API}?EventApplicationId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// GetInvoiceDetails_By_Id
export const getInvoiceDetailsById = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANGE_GETINVOICE_DETAILS_BY_ID_API}?EventApplicationId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//GET Invoice Add
export const getInvoiceAdd = async (id, type) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      `${apiendpoints.MANAGE_INVOICE_ADD_API}?EventApplicationId=${id}&ApplicationType=${type}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getInvoiceDetails = async (id) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(
      `${apiendpoints.MANAGE_INVOICE_DETAILS_ADD_API}?eventApplicationId=${id}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// INVOICE MAIN API
export const getInvoiceMainData = async (id, type, isadmin = false) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.MANAGE_INVOICE_MAIN}?eventApplicationId=${id}&type=${type}&isadmin=${isadmin}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

export const getAllInvoiceAdminReports = async (
  eventId,
  pageNumber = 1,
  pageSize = 1000
) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(
      `${apiendpoints.GET_ALL_INVOCIE_ADMIN}?pageNumber=${pageNumber}&pageSize=${pageSize}&eventId=${eventId}`
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
